import styled, { css } from 'styled-components';

const Left = styled.div<{ size?: number | string }>`
    flex: 0 0 auto;
    margin-left: right;
    ${p => p ? `width: ${p.size}rem;` : ''}
`;

const Right = styled.div<{ size?: number | string }>`
    flex: 0 0 auto;
    margin-left: auto;
    ${p => p ? `width: ${p.size}rem;` : ''}
`;

const Top = styled.div<{ size?: number | string }>`
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    ${p => p ? `height: ${p.size}rem;` : ''}
    margin-bottom: auto;
    & > * { flex: 1 1 auto }
    ${Left} { flex: 0 0 auto }
    ${Right} { flex: 0 0 auto }
`;

const Bottom = styled.div<{ size?: number | string }>`
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    ${p => p ? `height: ${p.size}rem;` : ''}
    margin-top: auto;
    & > * { flex: 1 1 auto }
    ${Left} { flex: 0 0 auto }
    ${Right} { flex: 0 0 auto }
`;

const Main = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
`;

const ViewFrame = styled.div<{ spacing?: number | string }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    /* & * {
        outline: solid 1px red;
    } */

    ${({ spacing }) => css`
        & > * > ${Left} { padding-right: ${spacing ?? 0}rem; }
        & > * > ${Right} { padding-left: ${spacing ?? 0}rem; }
        & > ${Top} { padding-bottom: ${spacing ?? 0}rem; }
        & > ${Bottom} { padding-top: ${spacing ?? 0}rem; }
    `}

`;

export const View = Object.assign(ViewFrame, {
    Bottom,
    Left,
    Main,
    Right,
    Top,
});
